import React from 'react';
import { useSelector } from 'react-redux';
import { getBoxscoreTeamsState } from '../store/selectors/getBoxscoreTeamsState';
import BoxscoreTeam from './BoxscoreTeam';
import PropTypes from 'prop-types';

const BoxscoreTeamContainer = (props) => {
    const { teams, language, abstractGameState } = useSelector(getBoxscoreTeamsState);
    const { team, syncBoxscoreInfo, expanded, showBullpen = false, showBench = false, list, displayGameInfoInline } = props;
    const lineups = teams[team];
    const { teamStats, team: { abbreviation = '' } = {} } = lineups;
    const isInProgress = abstractGameState === 'Live';

    return (
        <BoxscoreTeam
            lineups={lineups}
            language={language}
            teamAbbreviation={abbreviation}
            team={team}
            isInProgress={isInProgress}
            teamStats={teamStats}
            syncBoxscoreInfo={syncBoxscoreInfo}
            expanded={expanded}
            showBullpen={ showBullpen }
            showBench={ showBench }
            list={ list }
            displayGameInfoInline={displayGameInfoInline}
        />
    );
};

BoxscoreTeamContainer.propTypes = {
    team: PropTypes.string,
    expanded: PropTypes.bool,
    syncBoxscoreInfo: PropTypes.func,
    showBullpen: PropTypes.bool,
    showBench: PropTypes.bool,
    list: PropTypes.array,
    displayGameInfoInline: PropTypes.bool
};

export default BoxscoreTeamContainer;
